export default __webpack_public_path__ + "static/media/Croc4.587f0d00.png";